module.exports = __webpack_public_path__ + "img/1723012201724-WhatsApp Image 2024-08-01 at 18.58.55 1.jpeg.7eb34c0f.webp";